/* eslint-disable no-useless-escape */
import { Button, TextField } from '@shopify/polaris'
import { useEffect } from 'react'
import { relativeURL } from '../../../../urlHelper'

function GoToURL({ urlPath, setUrlPath, selectedMode, currentURL, setCurrentURL, fullUrl }) {

  useEffect(() => {
    setCurrentURL(fullUrl())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlPath])

  const validate = () => {
    try {
      const url = new URL(currentURL)
      return url.protocol === 'https:' && url.origin === new URL(fullUrl('/')).origin && !url.username && !url.password
    } catch (_) { return false }
  }

  const error = () => validate() ? '' : 'Invalid'

  const go = () => {
    if (!validate()) return
    // replace domain
    setUrlPath(relativeURL(currentURL))
    setCurrentURL(fullUrl(relativeURL(currentURL)))
  }

  if (selectedMode !== 'interact') return <></>

  return (
    <div className="GoToURL">
      <TextField value={currentURL} error={error()} onChange={setCurrentURL}></TextField>
      <Button primary onClick={go}>Go</Button>
    </div>
  )
}

export default GoToURL
